module.exports = __webpack_public_path__ + "assets/img/block-left-5f795f28.png";